// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RulesHelp_trigger__uArlX {
  padding: 3px 10px;
  font-size: 12px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  color: #838383;
  cursor: pointer;
}
.RulesHelp_trigger__uArlX:hover {
  border-color: #acacac;
}

.RulesHelp_content__fQhp6 {
  max-height: 70vh;
  max-width: 760px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.5;
}
.RulesHelp_content__fQhp6 h4 {
  margin: 0 0 4px;
  font-size: 13px;
}
.RulesHelp_content__fQhp6 p {
  margin: 0 0 8px;
}

.RulesHelp_section__H0i8h {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f4f5f7;
}

.RulesHelp_note__aDz1s {
  color: #838383;
}

.RulesHelp_rules__h1zyO {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 14px;
  margin: 0;
}
.RulesHelp_rules__h1zyO dt {
  margin: 0;
}
.RulesHelp_rules__h1zyO dd {
  margin: 0;
}

.RulesHelp_code__nh78h {
  font-weight: 600;
}

.RulesHelp_count__HUmE4 {
  margin-left: 6px;
  padding: 0 6px;
  font-size: 10px;
  font-weight: normal;
  background: #f4f5f7;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/RulesHelp/RulesHelp.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,eAAA;EACA,gBCQM;EDPN,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAFF;AAIE;EACE,qBCLO;ADGX;;AAMA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAKE;EACE,eAAA;EACA,eAAA;AAHJ;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,gBEzBS;EF0BT,iBE1BS;EF2BT,6BAAA;AALF;;AAQA;EACE,cChCS;AD2BX;;AAQA;EACE,aAAA;EACA,sCAAA;EACA,aAAA;EACA,SAAA;AALF;AAOE;EACE,SAAA;AALJ;AAQE;EACE,SAAA;AANJ;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBC9DS;ED+DT,kBAAA;AAPF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.trigger {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: $white;\n  border: 1px solid $grey-200;\n  border-radius: 12px;\n  color: $grey-400;\n  cursor: pointer;\n\n  &:hover {\n    border-color: $grey-300;\n  }\n}\n\n.content {\n  max-height: 70vh;\n  max-width: 760px;\n  overflow-y: auto;\n  font-size: 13px;\n  line-height: 1.5;\n\n  h4 {\n    margin: 0 0 4px;\n    font-size: 13px;\n  }\n\n  p {\n    margin: 0 0 8px;\n  }\n}\n\n.section {\n  margin-top: $margin-m;\n  padding-top: $margin-m;\n  border-top: 1px solid $grey-100;\n}\n\n.note {\n  color: $grey-400;\n}\n\n.rules {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: 6px 14px;\n  margin: 0;\n\n  dt {\n    margin: 0;\n  }\n\n  dd {\n    margin: 0;\n  }\n}\n\n.code {\n  font-weight: 600;\n}\n\n.count {\n  margin-left: 6px;\n  padding: 0 6px;\n  font-size: 10px;\n  font-weight: normal;\n  background: $grey-100;\n  border-radius: 8px;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `RulesHelp_trigger__uArlX`,
	"content": `RulesHelp_content__fQhp6`,
	"section": `RulesHelp_section__H0i8h`,
	"note": `RulesHelp_note__aDz1s`,
	"rules": `RulesHelp_rules__h1zyO`,
	"code": `RulesHelp_code__nh78h`,
	"count": `RulesHelp_count__HUmE4`
};
export default ___CSS_LOADER_EXPORT___;
